import type { DateRangeNullable } from "~/types/dateAndTimeTypes.ts";
import { doDateRangesWithOptionalEndDatesOverlap } from "~/utils/dateAndTimeUtils.ts";

export function applyDeliveryPeriodFilter<T extends {
	deliveryStartDate: Date,
	deliveryEndDate: Date
}>(deliveryPeriodFilterDates: DateRangeNullable, data: T[]): T[] {
	if (deliveryPeriodFilterDates.startDate && deliveryPeriodFilterDates.endDate) {
		const startDate = deliveryPeriodFilterDates.startDate;
		const endDate = deliveryPeriodFilterDates.endDate;

		return data.filter((item) => {
			return doDateRangesWithOptionalEndDatesOverlap({
				startDate: item.deliveryStartDate,
				endDate: item.deliveryEndDate,
			}, { startDate, endDate });
		});
	}
	return data;
}

type MixedDateRange = {
	endDate: null | string | Date;
	startDate: null | string | Date;
}

function castToDate(value: null | string | Date) {
	if (value === null) {
		return value;
	}

	try {
		return new Date(value);
	} catch (error: unknown) {
		return null;
	}
}

export function castFilterDatesToDate(dateRange: MixedDateRange): DateRangeNullable {
	return {
		endDate: castToDate(dateRange.endDate),
		startDate: castToDate(dateRange.startDate),
	};
}

